export function generateEmptyWeekArray() {
  return [0, 0, 0, 0, 0, 0, 0];
}
